module.exports = __webpack_public_path__ + "img/tractor-yellow.8514f48a.svg";